export default __webpack_public_path__ + "static/media/Tarim's Ring of the Holy Word.a19b8e04.jpg";